export default __webpack_public_path__ + "static/media/Pastry-Feijao.aa32361a.jpg";